// extracted by mini-css-extract-plugin
export default {"overlay":"ViewEmailModal_overlay__YaXC9","root":"ViewEmailModal_root__I0yXj","header":"ViewEmailModal_header__WAQ-D","message":"ViewEmailModal_message__1qGoh"};